import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: '대시보드',
    link: '/dashboard',
  },
  {
    id: 2,
    label: '회원관리',
    link: '/users',
  },
  {
    id: 3,
    label: 'G 포인트 관리',
    link: '/point',
  },
  {
    id: 4,
    label: '이용약관',
    link: '/term',
  },
  {
    id: 5,
    label: '개인정보처리방침',
    link: '/privacy',
  },
];
